import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const handleNavigation = (path: string) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  const handleContactClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-xs sm:text-sm uppercase tracking-wide">
              {t('footer.company')}
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button 
                  onClick={() => handleNavigation('/about')}
                  className="text-slate-400 hover:text-white transition-colors text-xs sm:text-sm text-left cursor-pointer"
                >
                  {t('footer.about')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/privacy-policy')}
                  className="text-slate-400 hover:text-white transition-colors text-xs sm:text-sm text-left cursor-pointer"
                >
                  {t('footer.privacyPolicy')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/terms-of-service')}
                  className="text-slate-400 hover:text-white transition-colors text-xs sm:text-sm text-left cursor-pointer"
                >
                  {t('footer.termsOfService')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/cookie-policy')}
                  className="text-slate-400 hover:text-white transition-colors text-xs sm:text-sm text-left cursor-pointer"
                >
                  {t('footer.cookiePolicy')}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-xs sm:text-sm uppercase tracking-wide">
              {t('footer.contact')}
            </h4>
            <div className="space-y-2 sm:space-y-3">
              <p className="text-white font-medium text-xs sm:text-sm">NovaVenture Group BV</p>
              <p className="text-slate-400 text-xs sm:text-sm">Krommestraat 48</p>
              <p className="text-slate-400 text-xs sm:text-sm">2830 Blaasveld, België</p>
              <p className="text-slate-400 text-xs sm:text-sm mt-2">BTW: BE1006303437</p>
              <ul className="space-y-2 sm:space-y-3 mt-3">
                <li className="flex items-center gap-2 text-slate-400 text-xs sm:text-sm">
                  <i className="ri-phone-line flex-shrink-0"></i>
                  <a href="tel:+32488139664" className="hover:text-teal-400 transition-colors cursor-pointer break-all">
                    +32 488 13 96 64
                  </a>
                </li>
                <li className="flex items-center gap-2 text-slate-400 text-xs sm:text-sm">
                  <i className="ri-mail-line flex-shrink-0"></i>
                  <a href="mailto:david@novaventure.be" className="hover:text-teal-400 transition-colors cursor-pointer break-all">
                    david@novaventure.be
                  </a>
                </li>
                <li className="flex items-start gap-2 text-slate-400 text-xs sm:text-sm">
                  <i className="ri-map-pin-line mt-0.5 flex-shrink-0"></i>
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Krommestraat+48+2830+Blaasveld+Belgium" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    Krommestraat 48, 2830 Blaasveld
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs sm:text-sm text-center md:text-left">
            © 2025 Novaventure. {t('footer.allRightsReserved')}.
          </p>
        </div>
      </div>
    </footer>
  );
}